import React, { useState } from "react";
import {
  Button,
  CardActions,
  CardContent,
  CardProps,
  Typography,
} from "@material-ui/core";
import { useHistory, useLocation, useParams } from "react-router";
import { CardLoading } from "../../../../components/card-loading";
import { listNotes } from "../../../../sdk/release-admin";

export const ArtistSummaryNotes: React.FC<CardProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { artistId } = useParams<{ artistId: string }>();

  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    listNotes(artistId)
      .then((data) => {
        setTotal(data.results.length);
      })
      .finally(() => setLoading(false));
  }, [artistId]);

  return (
    <CardLoading
      {...props}
      style={{ width: "200px", ...props.style }}
      loading={loading}
    >
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Notes
        </Typography>
        <Typography variant="h5" component="h2">
          {total.toLocaleString()}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() =>
            history.push(`${location.pathname}/notes`, location.state)
          }
        >
          View all
        </Button>
      </CardActions>
    </CardLoading>
  );
};
